export default "__VITE_ASSET__DG0ggonO__"